import React from 'react';
import PropTypes from 'prop-types';

import { Locales } from '@ratehub/base-ui';
import { INSURANCE_TYPES } from '@ratehub/ins-common';

import withFrenchLocale from '../functions/withFrenchLocale';
import createSPAStaticProps from '../functions/createSPAStaticProps';
import LifeQuotesPage from '../components/LifeQuotesPage';


function Page({ locale, content }) {
    return (
        <LifeQuotesPage
            locale={locale}
            brokers={content.brokers}
            insurers={content.insurers}
        />
    );
}

const { getStaticPaths, getStaticProps } = createSPAStaticProps({
    locale: Locales.FRENCH,
    fileName: 'spaInsLifeQuotesFR', // Must match filename use for catch all, i.e. [...ccDetailsSlugEN].jsx
    path: '/assurance/soumission-de-la-vie',

    options: {
        includeInsuranceProviders: true,
        insuranceType: INSURANCE_TYPES.LIFE,
    },
});

Page.propTypes = {
    locale: PropTypes.string.isRequired,
    content: PropTypes.shape({
        brokers: PropTypes.arrayOf(PropTypes.object),
        insurers: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
};

export default withFrenchLocale(Page);
export { getStaticPaths, getStaticProps };
